import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DndPandaLayout from './components/layouts/DndPandaLayout';

const App = () => {

     return (
          <DndPandaLayout />
     );
};

export default App;
